import React, { useState } from 'react';
import localeLookup from '../../config/locale';
import ModalWrapper from './ModalWrapper';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import BoxMessage from '../BoxMessage';
import TextField from '../formElements/TextField';
import isEqual from 'lodash/isEqual';

const StandardDurationModal = ({ 
  title,
  subtitle,
  body,
  onClose,
  onConfirm,
  btnConfirmTitle = localeLookup('translations.Save'),
  btnRejectTitle = localeLookup('translations.Cancel'),
  btnConfirmKind = 'darkui',
  infoText,
  infoTextType,
  infoTextIcon,
  dismissable,
  initialValue = '0',
}) => {
  const [inputValue, setInputValue] = useState(initialValue === '0' ? '-' : initialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const validateInput = (value) => {
    if (value === '-' || value.trim() === '') {
      return { error: '' };
    }
    
    const numValue = Number(value);
    
    if (isNaN(numValue) || numValue < 0 || !Number.isInteger(numValue)) {
      return { 
        error: localeLookup('translations.Only positive whole numbers are allowed')
      };
    }

    if (numValue > 9999) {
      return { 
        error: localeLookup('translations.The maximum allowed value is {0}', [9999])
      };
    }
    
    return { error: ''};
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    
    let newValue;
    if (inputValue === '-') {
      newValue = value.replace(/\D/g, '');
    } else if (value === '') {
      newValue = value;
    } else {
      const valueAsInt = parseInt(value);
      if (!isNaN(valueAsInt) && valueAsInt >= 0) {
        newValue = valueAsInt.toString();
      } else {
        return;
      }
    }

    setInputValue(newValue);
    const validation = validateInput(newValue);
    setError(validation.error);
  };

  const handleConfirm = () => {
    setIsSubmitting(true);
    const valueToSubmit = (inputValue === '-' || inputValue.trim() === '') ? '0' : inputValue;
    if (onConfirm) onConfirm(valueToSubmit);
    if (onClose) onClose();
  };

  const handleCancel = () => {
    if (onClose) onClose();
  };

  const handleBlur = () => {
    if (inputValue === '0' || inputValue.trim() === '') {
      setInputValue('-');
    }
  };

  return (
    <ModalWrapper>
      <ModalHeader
        title={title}
        subtitle={subtitle}
        onClose={onClose}
        dismissable={dismissable}
      />
      
      {infoText && (
        <BoxMessage
          type={infoTextType}
          spacing="md"
          icon={infoTextIcon || 'info-circle'}
        >
          {infoText}
        </BoxMessage>
      )}

      <ModalBody>
        {body}
        <div className="normalize-time-modal__standard-duration-input-container">
          <TextField
            type="text"
            value={inputValue}
            maxLength={5}
            className="normalize-time-modal__standard-duration-input"
            onChange={handleInputChange}
            onBlur={handleBlur}
            autoFocus={true}
            error={error}
          />
          <span className="normalize-time-modal__standard-duration-label">
            {localeLookup('translations.Days')}
          </span>
        </div>
      </ModalBody>

      <ModalFooter
        onCancelClick={handleCancel}
        cancelButtonText={btnRejectTitle}
        confirmButtonText={btnConfirmTitle}
        confirmButtonKind={btnConfirmKind}
        onConfirmClick={handleConfirm}
        confirmDisabled={isSubmitting || !!error || isEqual(initialValue, inputValue)}
      />
    </ModalWrapper>
  );
};

export default StandardDurationModal;